import { createTheme } from '@mui/material/styles';

// Simplified Material UI theme - using minimal customization to avoid errors
const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#0d294e',
      light: '#1e3a64',
      dark: '#08193a',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#f5bc3b',
      light: '#f7c85e',
      dark: '#d4a331',
      contrastText: '#000000',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});

export default muiTheme; 